import React from "react"
import { ui } from "../../../shared/styles/uiSystem"

export default function PatientWorkspaceLayout({
  isStacked = false,
  leftPanel,
  emptyState = null,
  header = null,
  tabs = null,
  children,
  leftWidth = 300,
  minHeight = 480
}) {
  const shellGap = isStacked ? 10 : 12
  const headerPadding = isStacked ? "10px" : "10px 12px"
  const tabsPadding = isStacked ? "7px 10px" : "8px 12px"
  const bodyPadding = isStacked ? 10 : 12

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isStacked ? "1fr" : `minmax(260px, ${leftWidth}px) minmax(0,1fr)`,
        gap: shellGap,
        alignItems: "start",
        minWidth: 0
      }}
    >
      {leftPanel}

      <div
        style={{
          ...ui.card,
          minHeight: emptyState ? "auto" : isStacked ? "auto" : minHeight,
          overflow: "hidden",
          minWidth: 0
        }}
      >
        {emptyState ? (
          emptyState
        ) : (
          <>
            {header ? (
              <div
                style={{
                  padding: headerPadding,
                  borderBottom: "1px solid #e2e8f0",
                  background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)"
                }}
              >
                {header}
              </div>
            ) : null}

            {tabs ? (
              <div
                style={{
                  padding: tabsPadding,
                  borderBottom: "1px solid #e2e8f0",
                  background: "rgba(255,255,255,0.96)",
                  backdropFilter: "blur(8px)",
                  position: "sticky",
                  top: 0,
                  zIndex: 2,
                  minWidth: 0
                }}
              >
                {tabs}
              </div>
            ) : null}

            <div style={{ padding: bodyPadding, minWidth: 0 }}>
              {children}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
